import { CheckIcon } from "@radix-ui/react-icons";
import { Button, Callout, Flex, Text, TextArea } from "@radix-ui/themes";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { BookingFeedbackRequest } from "use-smart-locks-shared";
import { submitBookingFeedback } from "../../../shared/api/nest-api";
import { useGenericErrorHandler } from "../../../shared/hooks/use-generic-error-handler";
import { useCampingBooking } from "../../hooks/use-camping-booking";
import { Rating } from "./rating.component";

export function EndBookingFeedback() {
  const { booking } = useCampingBooking();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const { handleError } = useGenericErrorHandler();

  const {
    mutate: submitFeedback,
    isPending,
    isSuccess,
  } = useMutation({
    mutationFn: (data: BookingFeedbackRequest) => {
      return submitBookingFeedback(booking.id, data);
    },
    onError: (error) => {
      handleError(
        error,
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
      );
    },
  });

  const isFeedbackSubmitted = isSuccess || Boolean(booking.feedbackSubmittedAt);

  return (
    <Flex direction="column" gap="3">
      <Callout.Root color="green">
        <Callout.Icon>
          <CheckIcon />
        </Callout.Icon>
        <Callout.Text>
          Ihre Buchung wurde beendet, vielen Dank für Ihr Vertrauen!
        </Callout.Text>
      </Callout.Root>

      {isFeedbackSubmitted ? (
        <Callout.Root color="green">
          <Callout.Icon>
            <CheckIcon />
          </Callout.Icon>
          <Callout.Text>
            Vielen Dank für Ihr Feedback! Wir schätzen Ihre Meinung sehr.
          </Callout.Text>
        </Callout.Root>
      ) : (
        <Flex direction="column" gap="3" mt="2">
          <Text as="div" size="2">
            Wie hat Ihnen die Buchung gefallen?
          </Text>
          <Rating value={rating} onChange={setRating} />
          <Text as="div" size="2">
            Wofür haben Sie die Buchung genutzt?
          </Text>
          <TextArea
            placeholder="z. B. Fahrt vom Bahnhof zur Uni, Einkaufen, Ausflug ins Grüne. Ihre Meinung ist uns wichtig – hier können Sie auch gerne eine Schadensmeldung abgeben."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{ minHeight: "100px" }}
          />
          <Button
            onClick={() => submitFeedback({ rating, comment })}
            disabled={rating === 0}
            loading={isPending}
          >
            Feedback absenden
          </Button>
        </Flex>
      )}
    </Flex>
  );
}
